import React from "react";
import { Route } from "react-router-dom";
import { BeneficialOwnersScreen } from "../../components/BeneficialOwnersScreen";
import { ControllersScreen } from "../../components/ControllersScreen";
import { JointAccountDetails } from "../../components/details/JointAccountDetails";
import { DocumentCollectorInvestor } from "../../components/documents/DocumentCollectorInvestor";
import { DocumentDetailsInvestor } from "../../components/documents/DocumentDetailsInvestor";
import { IndividualProfileEditScreen } from "../../components/IndividualProfileEditScreen";
import { InstitutionEditScreen } from "../../components/InstitutionEditScreen";
import { OwnerThresholdContainer } from "../../components/OwnerThresholdContainer";
import { ProfileDeclaration } from "../../components/profile/ProfileDeclaration";
import { ProfileActionOverview } from "../../components/ProfileActionOverview";
import { ProfileTree } from "../../components/ProfileTree";
import { useComplianceCaseContext } from "../ComplianceCaseContext";

export type RouteGuard = (component: React.ComponentType) => React.ReactNode;

export type ComplianceRoutesProps = {
  basePath: string;
  onStepCompletion: () => void;
  routeGuard?: RouteGuard;
};

export const ComplianceRoutes: React.FC<ComplianceRoutesProps> = ({
  basePath,
  onStepCompletion,
  routeGuard,
}) => {
  const { enableLPUXv2 } = useComplianceCaseContext();
  const renderWithGuard = (Component: React.ComponentType) => {
    return routeGuard ? routeGuard(Component) : <Component />;
  };

  return (
    <>
      <Route path={`${basePath}/overview`} exact>
        <ProfileTree onStepCompletion={onStepCompletion} />
      </Route>
      <Route path={`${basePath}/overview/:profileId`} exact>
        <ProfileActionOverview onStepCompletion={onStepCompletion} />
      </Route>
      <Route path={`${basePath}/documents/:profileId`} exact>
        {enableLPUXv2 ? (
          <DocumentDetailsInvestor onStepCompletion={onStepCompletion} />
        ) : (
          <DocumentCollectorInvestor onStepCompletion={onStepCompletion} />
        )}
      </Route>
      <Route path={`${basePath}/owners/:profileId`} exact>
        <BeneficialOwnersScreen />
      </Route>
      <Route path={`${basePath}/controllers/:profileId`} exact>
        <ControllersScreen />
      </Route>
      <Route path={`${basePath}/owners/threshold-check/:profileId`} exact>
        {renderWithGuard(OwnerThresholdContainer)}
      </Route>
      <Route path={`${basePath}/upsert-owners/:profileId/:id?`} exact>
        <ProfileDeclaration controllerMode={false} />
      </Route>
      <Route path={`${basePath}/upsert-controllers/:profileId/:id?`} exact>
        <ProfileDeclaration controllerMode={true} />
      </Route>
      <Route path={`${basePath}/edit-individual/:profileId`} exact>
        {renderWithGuard(IndividualProfileEditScreen)}
      </Route>
      <Route path={`${basePath}/edit-institution/:profileId`} exact>
        {renderWithGuard(InstitutionEditScreen)}
      </Route>
      <Route path={`${basePath}/edit-joint/:profileId`} exact>
        {renderWithGuard(JointAccountDetails)}
      </Route>
    </>
  );
};
